module.exports = __webpack_public_path__ + "static/media/my-trips-hovered.5b235791.svg";